import React from "react";
import SelectedCardContainer from "../SelectedCardContainer/SelectedCardContainer";
import NumberTable from "../NumberTable/NumberTable";
import CardsContainer from "../CardsContainer/CardsContainer";
import { useGameStateStore } from "../../stores/gameStateStore";

import "./LeftContainer.css"


export default function LeftContainer({ flexValue = 1 }) {
  const roundStatus = useGameStateStore(c => c.roundStatus);

  return (
    <div className="left-container" style={{ flex: flexValue }}>
      {
        roundStatus === "waiting"
          ? <CardsContainer />
          : <>
            <SelectedCardContainer />
            <NumberTable />
          </>
      }

    </div>
  )
}